import { useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';

import { useFormatMessage } from '../../../../hooks';
import { ICompany } from '../../../../interfaces/companies';
import { actions as profileActions } from '../../../../store/ducks/profile.duck';
import { useCompany } from './useCompany';

const getInitialValues = (company?: ICompany | null) => ({
  name: company?.name || '',
  inn: company?.inn || '',
  phone_number: company?.phone_number || '',
  roles: 'ROLE_BUYER',
});

export const useFormikCompany = (company?: ICompany | null, countryData?: any) => {
  const fm = useFormatMessage();
  const dispatch = useDispatch();
  const { loading, success, edit, add } = useCompany();
  const formik = useFormik({
    initialValues: getInitialValues(company),
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      roles: Yup.string().required(fm('AUTH.VALIDATION.REQUIRED_FIELD')).nullable(),
      name: Yup.string().required(fm('AUTH.VALIDATION.REQUIRED_FIELD')).nullable(),
      inn: Yup.string().required(fm('AUTH.VALIDATION.REQUIRED_FIELD')).nullable(),
      phone_number: Yup.string()
        .required(fm('AUTH.VALIDATION.REQUIRED_FIELD'))
        .nullable()
        .test('mask-length', fm('AUTH.VALIDATION.REQUIRED_FIELD'), function (value) {
          if (!value) return true;
          const currentMaskLength = countryData?.mask?.replace(/[^*]/g, '').length;

          return value.length === currentMaskLength;
        }),
    }),
    onSubmit: submitValues => {
      if (company) {
        edit(+company.id, {
          ...submitValues,
          roles: submitValues?.roles ? [submitValues?.roles] : null,
          countryCode: +countryData.code || 7,
        });
      } else {
        add({
          ...submitValues,
          roles: submitValues?.roles ? [submitValues?.roles] : null,
          countryCode: +countryData.code || 7,
        });
      }
    },
  });

  useEffect(() => {
    if (success) {
      dispatch(profileActions.fetchRequest());
    }
  }, [success]);

  return { formik, loading };
};
